__turbopack_context__.v({
  "content": "qlgkoq_content",
  "header": "qlgkoq_header",
  "wrapper": "qlgkoq_wrapper",
});
